export default {"src":"/_next/static/media/instagram-icon.62c92c6f.svg","height":32,"width":33};